export const DEFAULT_BOOKED_SLOTS = [{ startTime: "09:00", endTime: "17:00" }];

export const MARK_DAY_AS_AVAILABLE_BY_DEFAULT = true;

export const DAYS = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

export const DEFAULT_SLOT_INTERVAL = 30;

export const HOUR_FORMATS = { H24: "24h", H12: "12h" };
export const DEFAULT_HOUR_FORMAT = HOUR_FORMATS.H24;
